import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React, { Children, cloneElement, isValidElement } from 'react';
import { cn } from "../v2/utils";
import { jsx as _jsx } from "react/jsx-runtime";
export function Tabs(_ref) {
  var children = _ref.children,
    scrollable = _ref.scrollable,
    className = _ref.className,
    _ref$full = _ref.full,
    full = _ref$full === void 0 ? true : _ref$full,
    onTabChange = _ref.onTabChange,
    valueProp = _ref.value;
  var value = valueProp || 0;
  var tabsChildren = Children.map(children, function (child, index) {
    if (/*#__PURE__*/isValidElement(child)) {
      /* Cloning the child element and adding an onClick event to it. */
      var childValue = child.props.value === undefined ? index : child.props.value;
      var onClick = function onClick(e) {
        if (typeof onTabChange === 'function') {
          onTabChange(childValue);
        }
        if (typeof child.props.onClick === 'function') {
          child.props.onClick(e);
        }
      };
      return /*#__PURE__*/cloneElement(child, _objectSpread({
        selected: childValue === value,
        onClick: onClick,
        value: childValue
      }, child.props));
    }
    return child;
  });
  return /*#__PURE__*/_jsx("div", {
    className: cn("tw-inline-flex tw-z-2 tw-max-w-full tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-800 tw-transition-colors tw-duration-150", scrollable ? 'tw-overflow-auto' : 'tw-overflow-hidden', full && 'tw-w-full', className),
    children: tabsChildren
  });
}
export default Tabs;